import React from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, LazyImage, MainHeading, SpanStyled } from '../../ui/Elements'
import { AboutBg, AboutImg, ArrowBtnBrown, StatsBg1, StatsBg2, StatsBg3, StatsBg4, StripeBg, StripeBgAr } from '../../ui/AllImages'

import { useTranslation } from 'react-i18next'
import { AboutBox } from '../../ui/CustomElements'
import i18n from '../../Languages/INEXT'
const About = () => {
    const { t } = useTranslation()
    
    return (
        <Box  id='about'>
            <AboutWapper className='container-fluid secAbout common-space'>
                <Container>
                    <Row className='about-row'>
                        
                        <Col lg={6} md={12} className='about-arabic'>
                            <Box className='aboutContent'>
                                
                                <MainHeading className='main-heading mb-3 main-heading-about' size="40px">
                                    {t('aboutHeading')}
                                </MainHeading>
                                <SpanStyled className='aboutDesc mb-4'>
                                    {t('aboutTxt1')}
                                    <br></br><br></br>
                                    {i18n.language === "ar" ? 
                                        <>
                                            {t('aboutTxt2')} <SpanStyled className='engReg'>{t('2030')}</SpanStyled>{t('aboutTxt3')}
                                        </>
                                    : 
                                        <>
                                            {t('aboutTxt2')}
                                        </>
                                    }
                                    

                                </SpanStyled>

                               
                                
                            </Box>
                        </Col>
                        <Col lg={6} md={12} className='about-col about-col-img'>
                            <Box className='abouImg'>
                                <LazyImage src={AboutImg} />
                                
                            </Box>
                            
                            
                        </Col>
                    </Row>
                </Container>
                
            </AboutWapper>
            
        </Box>
    )
}
const AboutWapper = styled.section`
    background-image: url(${AboutBg});
    background-size: cover;
    background-position: bottom center;
    .about-row {
        align-items: center;
    }
    .aboutContent{
        padding-right: 100px;
    }
    .abouImg{
        border-radius: 24px;
        overflow: hidden;
        span{
            width: 100%;
            height: 100%;
            img{
                width: 100%;
                height: auto;
            }
        }
    }
    
    
    body.rtl &{
        .abtHeadSec{
            font-size: 24px;
        }
        .aboutContent{
            padding-right: 0px;
            padding-left: 100px;
        }
    }
    @media (max-width: 1199px) {
        .aboutContent {
            padding-right: 30px;
        }
        body.rtl &{
            .aboutContent{
                padding-right: 0px;
                padding-left: 30px;
            }
        }
    }
    @media (max-width: 991px) {
        .about-col{
            margin-bottom: 40px;
        }
        .about-col-img{
            display: none;
        }
        &.secAbout{
            padding-top: 60px;
            padding-bottom: 30px;
        }
        .main-heading-about{
            font-size: 35px;
        }
        .aboutContent{
            padding-right: 0;
        }
        body.rtl &{
            .aboutContent{
                padding-right: 0px;
                padding-left: 0px;
            }
        }
        
    }
    @media (max-width: 767px) {
        
    }
    @media (max-width: 575px) {
        &.secAbout{
            padding-top: 50px;
            padding-bottom: 20px;
        }
        .main-heading-about{
            font-size: 30px;
        }
    }
`
export default About
